import React from 'react';
import { connect } from 'react-redux';
import UnavailablePlaceHolder from './UnavailablePlaceHolder';

const UnavilableHanlder = ({ isAppUnavailable, children }) => (isAppUnavailable ? <UnavailablePlaceHolder /> : children);

const mapStateToProps = ({ appStatus: { isAppUnavailable } }) => ({ isAppUnavailable });
export default connect(mapStateToProps)(UnavilableHanlder);
